// extracted by mini-css-extract-plugin
export default {"trigger":"Trigger_trigger__+ZYFu","icon":"Trigger_icon__+I-ba"};